module.exports = __webpack_public_path__ + "img/service.610458ec.png";